import { Link } from 'react-router-dom';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg border border-gray-200 p-8 md:p-12 text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-primary-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg
              className="w-12 h-12 text-primary-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About Us
          </h1>
          <div className="inline-block bg-yellow-100 text-yellow-800 px-6 py-3 rounded-full text-lg font-semibold mb-6">
            Coming Soon!
          </div>
        </div>

        <p className="text-lg text-gray-600 mb-8">
          We're working on telling our story. Check back soon to learn more about
          PermitBuddy and our mission to help electrical contractors save time on
          permit research.
        </p>

        <div className="space-y-4">
          <p className="text-gray-700">
            In the meantime, feel free to explore our product or get in touch with
            any questions.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Link
              to="/product"
              className="btn btn-primary px-6 py-2.5"
            >
              Learn About Our Product
            </Link>
            <Link
              to="/contact"
              className="btn btn-secondary px-6 py-2.5 flex items-center justify-center gap-2"
            >
              <EnvelopeIcon className="w-5 h-5" />
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
